import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, IconButton, IconEdit, Space } from '@redlink/components/atoms';

export const ProfileSection = memo(
  ({ title, description, onPress, children }) => {
    const { styles, colors } = useStyle();
    return (
      <>
        <View style={styles.profileItemHeaderContainer}>
          <View style={styles.profileItemHeaderTextsContainer}>
            <Text style={styles.titleText}>{title}</Text>
            <Space size={8} />
            <Text style={styles.profileItemDescriptionText}>{description}</Text>
          </View>
          <IconButton style={styles.iconButton} {...{ onPress }}>
            <IconEdit color={colors.white} size={18} />
          </IconButton>
        </View>
        <View style={styles.childrenContainer}>{children}</View>
      </>
    );
  }
);

const useStyle = createUseStyle(({ colors }) => ({
  profileItemHeaderContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  profileItemHeaderTextsContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  iconButton: {
    backgroundColor: colors.blue1,
    width: 36,
    height: 36,
  },
  profileItemDescriptionText: {
    color: colors.gray21,
    fontSize: 10,
  },
  childrenContainer: {
    marginVertical: 8,
  },
  titleText: {
    color: colors.black
  }
}));
